import { Col, Row, Space, Typography } from 'antd';
import React, { FC } from 'react';
import { AmountField } from '~/components';
import { TransferIcon } from '~/img';
import theme from '~/theme';
import { Transaction } from '~/types';
import TransactionDetails from './TransactionDetails';
import ViewMoreDetails from './ViewMoreDetails';
import styled from 'styled-components';
import { useDirection } from '~/hooks';

interface ResultProps {
  trx: Transaction | null;
}

const CenteredContainer = styled.div`
  margin-bottom: 24px;
  text-align: center;
`;

const IconContainer = styled.div`
  font-size: 80px;
  color: ${theme.primaryColor};
`;

const RecipientName = styled(Typography.Title)`
  margin-top: 8px;
  font-size: 21px;
  font-weight: 600;
`;

const DescriptionContainer = styled(Space)`
  margin-bottom: 40px;
  margin-top: 40px;
`;

const Result: FC<ResultProps> = ({ trx }) => {
  const [direction] = useDirection();
  return (
    <Row justify="center" align="middle">
      <Col xs={24} sm={20} md={16} lg={12} xl={10}>
        <CenteredContainer>
          <IconContainer>
            <TransferIcon />
          </IconContainer>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <RecipientName
              level={4}
              style={{ direction: 'ltr', textAlign: direction === 'rtl' ? 'right' : undefined }}
            >
              {trx?.details?.recipientName}
            </RecipientName>
          </div>
          <div>
            <Space direction="vertical" size={16}>
              <Typography.Text
                type="secondary"
                style={{ direction: 'ltr', textAlign: direction === 'rtl' ? 'right' : undefined }}
              >
                {trx?.description}
              </Typography.Text>
            </Space>
          </div>
          <DescriptionContainer direction="vertical" size={16}>
            <Typography.Text
              style={{
                fontSize: '32px',
                fontWeight: 600,
              }}
            >
              <AmountField
                amount={trx?.totalAmount}
                className={getAmountClassNameByStatus(trx?.status || '')}
              />
            </Typography.Text>
          </DescriptionContainer>
        </CenteredContainer>
        <div>
          {trx?.id && <TransactionDetails transaction={trx} />}
          {trx?.id && <ViewMoreDetails result={trx} />}
        </div>
      </Col>
    </Row>
  );
};

export const getAmountClassNameByStatus = (status: string) => {
  switch (status) {
    case 'COMPLETED':
      return '';
    default:
      return `status-color__${status}`;
  }
};

export default Result;
